import React from "react";
import { Consume } from "../../../Context/Consumer";
import { PlayerCardContext} from "../../../Context";
import config from "../../../common/config";
import { getTrans, makeClasses } from "../../../common/";
import Swiper from "react-id-swiper";
import PlayerImage from "../../playerImage";

const MostPicked = (props) => {
  let {trans,statitics,players} = props;
  const params = {
    slidesPerView: 3,
    navigation: {
      nextEl: `.swiper-button-next`,
      prevEl: `.swiper-button-prev`,
    },
  };

  const playerTab = (playerDetails) => {
    let player = {};
    player.details = playerDetails;
    player.id = playerDetails.Id;
    player.skill = playerDetails.Skill;
    props.PlayerCardData.setPlayer(player);
    props.PlayerCardData.showHidePlyrCard();
  }

  let mostPicked = (heading, playersArr) => {
    let playerArr = playersArr.sort((a, b) => {
      return b.Percentage - a.Percentage;
    });
    return (
      <div className="si-card">
        <div className="si-cardRow">
          <div className="si-heading">
            <span>{heading}</span>
          </div>
          <div className="si-plyrList">
            <Swiper {...params}>
              {playerArr.map((player) => {
                let playerObj = players.data.playerList.find(el=>{
                  return el?.Id == player?.PlayerID; 
                })
                const playerClass = makeClasses({
                  "si-injury": playerObj?.PlayerStatus === config.enumPlayerStatus.Injured,
                  "si-suspended": playerObj?.PlayerStatus === config.enumPlayerStatus.Suspended,
                  "si-doubtful": playerObj?.PlayerStatus === config.enumPlayerStatus.Doubtful,
                });
                return (
                  <div className={`si-plyrSel ${playerClass}`} key={player.PlayerID} onClick={()=>playerTab(playerObj)}>
                    <PlayerImage
                      playerId={player.PlayerID}
                      teamId={player.TeamId}
                    />
                    <div className="si-plyrSel__name">
                      <span className="si-plyrSel__firstName">
                        {player.Name}
                      </span>
                    </div>
                    <div className="si-plyrSel__percent">
                      <span>{player.Percentage}%</span>
                    </div>
                  </div>
                );
              })}
            </Swiper>
          </div>
        </div>
      </div>
    );
  };

  return (statitics.MostPicPlayer?.length !== 0 && statitics.MostPicCaptain?.length !== 0) ? (
    <>
    <div className="si-mostPicked__container">
      {mostPicked(
        getTrans(trans, "most_picked_player", "Most Picked Player"),
        statitics.MostPicPlayer
      )}
      {mostPicked(
        getTrans(trans, "most_picked_captain", "Most picked Captain"),
        statitics.MostPicCaptain
      )}
    </div>
    </>
  ) : null;
};

export default Consume(MostPicked,[PlayerCardContext]);
